"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEMPLATE = exports.PRESENTERS = exports.MEDIA = exports.EVENT = void 0;
var PRESENTERS = exports.PRESENTERS = 'presenters';
var MEDIA = exports.MEDIA = 'media';
var EVENT = exports.EVENT = 'Event media';
var TEMPLATE = exports.TEMPLATE = 'Templates';